export const SET_REGISTRATION_COMPLETE = 'SET_REGISTRATION_COMPLETE'
export const SET_REGISTRATION_OWNER_EMAIL = 'SET_REGISTRATION_OWNER_EMAIL'
export const SET_REGISTRATION_LOADING = 'SET_REGISTRATION_LOADING'
export const SET_REGISTRATION_OWNER_PHONE_NUMBER = 'SET_REGISTRATION_OWNER_PHONE_NUMBER'
